export enum EmailCampaignSendingOptionsPanelTypes {
  SHARE_ON_SOCIAL_MEDIA,
  SHARE_AS_WEBPAGE,
}
